import { useEffect } from 'react'
import i18n from '@translations/i18n'

export const useTranslationInit = (locale: string | undefined) => {
  useEffect(() => {
    if (locale) {
      const lang = locale?.split('-')?.[0] ?? 'en'
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }

      // use country specific namespace as first fallback
      const country = locale?.split('-')?.[1]
      if (country) {
        i18n.options.fallbackNS = [`translation_${country}`, 'translation']
      }
    }
  }, [locale])
}
